<script lang="ts" setup>
import { computed } from 'vue';
import { DataPoint } from '@/types';
import { getDefaultLocaleValue } from '../locales/default';

const props = defineProps<{
  dataPoint: any;
  locale: string;
  parentLabel: string;
  label: any;
  translations: Record<string, string>;
}>();

function getDataPointString(dataPoint: DataPoint) {
  switch (true) {
    // TODO Remove the second check once we can create appropriate objects in tests
    case dataPoint.value && dataPoint.value !== 0:
      // in the Body/Karosserie accordion, number of doors and seats has no unit
      const unit = dataPoint.unit ? dataPoint.unit : '';
      return `${dataPoint.value.toLocaleString(props.locale)} ${unit}`;
    case dataPoint.max && dataPoint.min && dataPoint.max === dataPoint.min:
      return `${dataPoint.max.toLocaleString(props.locale)} ${dataPoint.unit}`;
    case [dataPoint.max, dataPoint.min].every((e) => e != undefined):
      return `${dataPoint.min!!.toLocaleString(props.locale)} - ${dataPoint.max!!.toLocaleString(props.locale)} ${dataPoint.unit}`;
    default:
      return '';
  }
}

const value = computed((): string => {
  return getDataPointString(props.dataPoint);
});
</script>

<template>
  <tr>
    <th scope="row">
      {{
        translations[`owvc_tech_data_${parentLabel}_${label}`] ||
        getDefaultLocaleValue(`${parentLabel}_${label}`)
      }}
    </th>
    <td>
      {{ value.toLocaleString() }}
    </td>
  </tr>
</template>

<style lang="scss" scoped>
tr {
  border-bottom: 1px solid var(--wb-table-border-color);
}

tr:last-child {
  border-bottom: none;
}

td {
  white-space: nowrap;
}
</style>
